import { communicationsSubscriptionAdapter } from '../communications/adapters/communications-subscription.adapter';
import { standardSubscriptionAdapter } from './standard-subscription.adapter';
import type { RealtimeSubscriptionAdapter } from '../types/subscription-adapter.types';

/** Application composition: specialized policies precede the standard protocol. */
export const realtimeSubscriptionAdapters: readonly RealtimeSubscriptionAdapter[] =
  [communicationsSubscriptionAdapter, standardSubscriptionAdapter];
